module.exports = __webpack_public_path__ + "static/media/ent3.5aba62cc.png";